import { render, staticRenderFns } from "./veStuStipendShow.vue?vue&type=template&id=63237352&scoped=true"
import script from "./veStuStipendShow.vue?vue&type=script&lang=js"
export * from "./veStuStipendShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63237352",
  null
  
)

export default component.exports